import { ChartZoomControlTypes } from '../enums';

export const CHART_ZOOM_CONTROL_TYPES = {
    D3: ChartZoomControlTypes.D3,
    ECHARTS: ChartZoomControlTypes.ECHARTS,
    LEAFLET: ChartZoomControlTypes.LEAFLET
};
